import React, { memo } from 'react';
import DropdownButton from '../../../components/DropdownButtonMC';
import LoadingMC from '../../../components/LoadingMC';
import useCustomerOrderDeliveryStatusActions from '../../../hooks/inbox/actions/useCustomerOrderDeliveryStatusActions';
import useCustomerOrderDeliveryStatusUI from '../../../hooks/inbox/ui/useCustomerOrderDeliveryStatusUI';
import { useTraceUpdate } from '../../../hooks/shared/useDebugRenders';

const CustomerOrderDeliveryStatusSelectorMC = memo(({ order, updateOrderInList }) => {
  const {
    loading,
    handleStatusChange
  } = useCustomerOrderDeliveryStatusActions(order, updateOrderInList);

  const {
    deliveryStatusLabel,
    deliveryStatusOptions,
    containerClassNameDeliveryStatus
  } = useCustomerOrderDeliveryStatusUI(order, handleStatusChange);

  useTraceUpdate('CustomerOrderDeliveryStatusSelectorMC', {
    orderId: order?.id,
    deliveryStatus: order?.delivery_status,
    loading
  }, {
    logRenderCount: true,
    logPropChanges: true
  });

  if (loading) return <LoadingMC loading={loading} spinnerClassName="!tw-w-4 !tw-h-4" />;

  return (
    <DropdownButton
      variant="TEXT_PLAIN"
      text={deliveryStatusLabel}
      items={deliveryStatusOptions}
      containerClassName={containerClassNameDeliveryStatus}
      className={`!tw-h-[20px] !tw-min-h-0 !tw-py-1 !tw-px-1 ${containerClassNameDeliveryStatus}`}
    />
  );
});

CustomerOrderDeliveryStatusSelectorMC.displayName = 'CustomerOrderDeliveryStatusSelectorMC';

export default CustomerOrderDeliveryStatusSelectorMC;
